import farmacie from "..";

const routes = [
  {
    name: "FarmacieList",
    path: "/farmacie",
    component: farmacie.FarmacieListPage,
    meta: { title: "Farmacie" }
  },
  {
    name: "FarmacieEdit",
    path: "/farmacie/edit/:id",
    component: farmacie.FarmacieEditPage,
    meta: { title: "Farmacie - Edit" }
  },
  {
    name: "FarmacieView",
    path: "/farmacie/view/:id",
    component: farmacie.FarmacieViewPage,
    meta: { title: "Farmacie - View" }
  }
];

export default routes;